
const RequiredStar = () => {
    return (<>

        <span className="ml-5 required-star-wrap" style={{ marginLeft: "5px" }} ><b>*</b></span>
    </>)
}
export default RequiredStar;